import { useState, useEffect } from "react";
import {
    Box,
} from "@mui/material";
import ActionItems from "../../components/ActionItems/ActionItems";
import ActionItem from "../../components/ActionItems/ActionItem";
import useDisplaySnackbar from "../../utils/useDisplaySnackbar";
import useGlobalContext from "../../context/useGlobalContext";
import { initialSort } from "../../components/ActionItems/actionItemTableConfig";
import ProgressSpinner from "../../components/Common/ProgressSpinner";
import { ActionItemType } from "../../utils/types";
import ActionItemService from "../../services/actionItems/ActionItemService";
import { convertToUTC } from "../../utils/utils";
import SlideOver from "../Common/SlideOver";
const PeopleSearchActionItemsView: React.FC<{ personEmail: string, profileOrgId: string | undefined }> = ({ profileOrgId }) => {
    const { showSnackbar } = useDisplaySnackbar();
    const [attendees, setAttendees] = useState<any[]>([]);
    const [openDialog, setOpenDialog] = useState<boolean>(false);
    const [actionItems, setActionItems] = useState<any[]>([]);
    const [totalRecord, setTotalRecord] = useState(0);
    const [selectedActionItem, setSelectedActionItem] = useState<any | null>(null);
    const [showSpinner, setShowSpinner] = useState<boolean>(false);
    const [pageNumber, setPageNumber] = useState(1);
    const [pageSize, setPageSize] = useState(50);

    const [_filters, setFilters] = useState<{
        status: undefined | string;
    }>({
        status: "todo,in_progress",
    });

    const [sort, setSort] = useState(initialSort);
    const { startEndMeetingTime, accountDetails } = useGlobalContext();
    const [actionItemType, setActionItemType] = useState(ActionItemType.All);
    const [isPreview, setIsPreview] = useState<boolean>(false);
    const loggedInProfileOrgId = accountDetails?.profileOrgId ?? "";

    const [isActionItemValid, setIsActionItemValid] = useState(false);
        const [saveTrigger, setSaveTrigger] = useState(false);
          const [discardTrigger, setDiscardTrigger] = useState(false);
          const handleSave = () => setSaveTrigger(true);
          const handleDiscard = () => {
            (setDiscardTrigger(true), setOpenDialog(false));
          }
    
    const {
        isLoading: isMyActionsLoading,
        isFetching: isMyActionsFetching,
        isSuccess: isMyActionsDataSuccess,
        isError: isMyActionsDataError,
        error: myActionsDataError,
        data: myActionsData,
    } = ActionItemService.useGetGlobalSearchActionItems(
        {
            employeePorId: loggedInProfileOrgId,
            offset: pageNumber,
            limit: pageSize,
            startTime: convertToUTC(startEndMeetingTime?.start_time),
            endTime: convertToUTC(startEndMeetingTime?.end_time),
            sortOrder: sort.sort_order,
            sortBy: sort.sort_field,
            searchProfileOrgId: profileOrgId || "",
        },
        !!profileOrgId
      );

    useEffect(() => {
        const combinedActionItems = [];

        if (isMyActionsDataSuccess) {
            combinedActionItems.push(...(myActionsData?.data || []));
        }


        setActionItems(combinedActionItems);
        setTotalRecord(combinedActionItems.length);
        setShowSpinner(isMyActionsLoading || isMyActionsFetching);

        if (isMyActionsDataError) {
            showSnackbar("error", myActionsDataError);
        }
    }, [
        isMyActionsLoading,
        isMyActionsFetching,
        isMyActionsDataSuccess,
        isMyActionsDataError,
    ]);

    const onPageChange = (value: number) => {
        setPageNumber(value);
    };


    const onFilter = (value: {
        date: { start_time: string; end_time: string } | undefined;
        status: undefined | string;
    }) => {
        setFilters(value);
        setPageNumber(1);
    };

    const onTypeChange = (value: ActionItemType) => {
        setActionItemType(value);
        setPageNumber(1);
    };

    const onSort = (value: { sort_field: string; sort_order: string }) => {
        setSort(value as { sort_field: string; sort_order: "asc" | "desc" });
    };

    const handlePageSizeChange = (newPageSize: number) => {
        setPageSize(newPageSize);
    };

    const handleActionItemSelection = (actionItem: any) => {
        setOpenDialog(true);
        setSelectedActionItem(actionItem);
        setAttendees([actionItem?.assignee]);
    };

    const handleActionItemPreview = (actionItem: any) => {
        setOpenDialog(true);
        setSelectedActionItem(actionItem);
        setAttendees([actionItem?.assignee]);
        setIsPreview(true);
    };

    const handleClose = () => {
        setOpenDialog(false);
        setSelectedActionItem(null);
        setIsPreview(false);
    };

    return (
        <>
            <Box
                id="actionItemsParent"
                className="flex flex-col justify-start items-start gap-6"
                style={{ marginTop: "-10px" }}
            >

                <Box className="actionItemsContent w-full">
                    <Box>
                        <Box sx={{ marginTop: "20px" }}>
                            <ActionItems
                                type="MY_ACTION_ITEMS"
                                isLoading={isMyActionsLoading}
                                actionItems={actionItems}
                                totalRecord={totalRecord}
                                handleActionItemSelection={handleActionItemSelection}
                                handleActionItemPreview={handleActionItemPreview}
                                pageSize={pageSize}
                                onPageChange={onPageChange}
                                onFilter={onFilter}
                                onSort={onSort}
                                actionItemType={actionItemType}
                                onTypeChange={onTypeChange}
                                onPageSizeChange={(newPageSize: number | null | undefined) => {
                                    if (newPageSize !== null && newPageSize !== undefined) {
                                        handlePageSizeChange(newPageSize);
                                    }
                                }}
                            />
                        </Box>
                    </Box>
                </Box>
            </Box>

            <SlideOver 
            isOpen={openDialog} 
            onClose={handleClose}
            showHeaderButtons={true}
            onSave={handleSave}
            onDiscard={handleDiscard}
            discard={selectedActionItem != null ? false : true}
            saveDisabled={!isActionItemValid}
            >
            <ActionItem
                        actionItemType="MY_ACTION_ITEMS"
                        selectedActionItem={selectedActionItem}
                        attendees={attendees}
                        isPreview={isPreview}
                        handleClose={handleClose}
                        saveTrigger={saveTrigger}
                        discardTrigger={discardTrigger}
                        resetSaveTrigger={() => setSaveTrigger(false)}
                        onValidityChange={setIsActionItemValid}
                        resetDiscardTrigger={() => setDiscardTrigger(false)}
                        isNewActionItem= {false}
                        openDialog={openDialog}
                    />
            </SlideOver>
            <ProgressSpinner showSpinner={showSpinner} />
        </>
    );
};
export default PeopleSearchActionItemsView;